import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import LinkButton from "../Link/Link";
import LazyLoad from "react-lazyload";

export const SimpleCard = ({
  cardMedia,
  cardActionCollection,
  cardDescription,
  header,
  customClass,
  isCardLink = false,
  altText,
}) => {
  const renderCardActions = () =>
    cardActionCollection?.items?.map((action, ind) => (
      <LinkButton {...action} key={`Link-${ind + 1}`} />
    ));

  const content = useMemo(
    () => (
      <>

        <div className={!isCardLink ? `card ${customClass ?? ""}` : ""}>
          <LazyLoad offset={100} once>
            <img
              className="card-media"
              src={cardMedia.url}
              alt={altText ?? cardActionCollection?.items?.[0]?.url}
            />
          </LazyLoad>
          <div className="card-body">
            <h2>{header}</h2>
            <ReactMarkdown
              source={cardDescription}
              escapeHtml={false}
              disallowedTypes={[]}
              unwrapDisallowed
            />
            {!isCardLink && (
              <div className="card-actions">{renderCardActions()}</div>
            )}
          </div>
        </div>
      </>
    ),
    [
      cardMedia,
      cardActionCollection,
      cardDescription,
      header,
      customClass,
      isCardLink,
      altText,
    ]
  );
  return isCardLink ? (
    <a
      className={isCardLink && `card ${customClass ?? ""}`}
      aria-label={`Go to ${altText ?? cardActionCollection?.items?.[0]?.url}`}
      href={cardActionCollection?.items?.[0]?.url}
    >
      {content}
    </a>
  ) : (
    content
  );
};

SimpleCard.propTypes = {
  cardDescription: PropTypes.string,
  children: PropTypes.array.isRequired,
  header: PropTypes.string,
  cardMedia: PropTypes.object,
  cardActionCollection: PropTypes.object,
  customClass: PropTypes.string,
  isCardLink: PropTypes.bool,
};

export default SimpleCard;
